export default "__VITE_ASSET__Dw54XiB___"